import React, { createContext, useContext, useMemo, useState } from "react";
import PropTypes from "prop-types";
import {
    setRoom as setRoomService,
    setLocalVideoTrack as setLocalVideoTrackService,
    setLocalAudioTrack as setLocalAudioTrackService,
    setScreenShareLocalTrack as setScreenShareLocalTrackService,
    setLocalTracks as setLocalTracksService,
} from "../components/Twilio/Room/roomService";

const TwilioRoomContext = createContext();
export const TwilioRoomProvider = ({ children }) => {
    const [room, setRoom] = useState(null);
    const [localVideoTrack, setLocalVideoTrack] = useState(null);
    const [localAudioTrack, setLocalAudioTrack] = useState(null);
    const [screenShareLocalTrack, setScreenShareLocalTrack] = useState(null);
    const [localTracks, setLocalTracks] = useState(null);

    const updateRoom = (newRoom) => {
        setRoom(newRoom);
        setRoomService(newRoom); // Keep service in sync
    };

    const updateLocalVideoTrack = (newTrack) => {
        setLocalVideoTrack(newTrack);
        setLocalVideoTrackService(newTrack);
    };

    const updateLocalAudioTrack = (newTrack) => {
        setLocalAudioTrack(newTrack);
        setLocalAudioTrackService(newTrack);
    };

    const updateScreenShareLocalTrack = (newTrack) => {
        setScreenShareLocalTrack(newTrack);
        setScreenShareLocalTrackService(newTrack);
    };

    const updateLocalTracks = (newTrack) => {
        setLocalTracks(newTrack);
        setLocalTracksService(newTrack); // Sync with service
    };

    const contextValue = useMemo(
        () => ({
            room,
            setRoom: updateRoom,
            localVideoTrack,
            setLocalVideoTrack: updateLocalVideoTrack,
            localAudioTrack,
            setLocalAudioTrack: updateLocalAudioTrack,
            screenShareLocalTrack,
            setScreenShareLocalTrack: updateScreenShareLocalTrack,
            localTracks,
            setLocalTracks: updateLocalTracks,
        }),
        [room, localVideoTrack, localAudioTrack, screenShareLocalTrack, localTracks]
    );

    return <TwilioRoomContext.Provider value={contextValue}>{children}</TwilioRoomContext.Provider>;
};
TwilioRoomProvider.propTypes = {
    children: PropTypes.any,
};
export const useTwilioRoom = () => useContext(TwilioRoomContext);
